// Persistencia mínima en localStorage: identidad estable del navegador
// (sessionId) y datos para rehidratar la conversación entre visitas.
const KEYS = {
  sessionId: "flux.sessionId",
  convId: "flux.convId",
  sessionToken: "flux.sessionToken",
  entrySource: "flux.entrySource",
  pushDismissed: "flux.pushPromptDismissed"
};

function safeGet(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}

function safeSet(key, value) {
  try {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch { /* storage lleno o bloqueado: la app sigue sin persistencia */ }
}

export function getStableSessionId() {
  let id = safeGet(KEYS.sessionId);
  if (!id) {
    id = crypto.randomUUID();
    safeSet(KEYS.sessionId, id);
  }
  return id;
}

/**
 * Nueva identidad de navegador. La usa "cerrar sesión": el sessionId es el
 * channel_id de la conversación en el server, así que sin rotarlo el /start
 * siguiente REANUDA la misma conversación y su transcript vuelve a pintar los
 * mensajes de la cuenta anterior apenas se recarga la página.
 */
export function rotateSessionId() {
  const id = crypto.randomUUID();
  safeSet(KEYS.sessionId, id);
  return id;
}

export function getStoredConversation() {
  const convId = safeGet(KEYS.convId);
  const sessionToken = safeGet(KEYS.sessionToken);
  return convId && sessionToken ? { convId, sessionToken } : null;
}

export function storeConversation(convId, sessionToken) {
  safeSet(KEYS.convId, convId);
  safeSet(KEYS.sessionToken, sessionToken);
}

export function clearConversation() {
  safeSet(KEYS.convId, null);
  safeSet(KEYS.sessionToken, null);
}

export function rememberEntrySource(source) {
  if (source && source !== "direct") safeSet(KEYS.entrySource, source);
}

// El banner de push se ofrece una sola vez: el "Ahora no" queda persistido
// para no insistir en cada visita. La oferta de instalación NO se descarta:
// sigue visible mientras la app no esté instalada (ver installPrompt.js).
export function getPushPromptDismissed() {
  return safeGet(KEYS.pushDismissed) === "1";
}

export function setPushPromptDismissed() {
  safeSet(KEYS.pushDismissed, "1");
}
